const getDefaultState = () => {
  return {
    loading: false,
    treatmentSearch: "",
    procedureSearch: undefined,
    resendMail: { email: "", isBarVisible: false },
  }
}

const state = getDefaultState()

const getters = {
  isLoading: state => state.loading,
  resendMail: state => state.resendMail,
  treatmentSearch: state => state.treatmentSearch,
  procedureSearch: state => state.procedureSearch,
}

const mutations = {
  setLoading: (state, { data }) => {
    state.loading = data
  },
  setTreatment: (state, data) => {
    state.treatmentSearch = data
  },
  setProcedure: (state, data) => {
    state.procedureSearch = data
  },
  setMail: (state, data) => {
    console.log(data, "in store to unvierfied email")
    state.resendMail.email = data.email
    state.resendMail.isBarVisible = data.isVisible
  },
}

const actions = {
  //
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js